import { useState } from 'react';
import ChartWidget from '../components/ChartWidget';
import CapSeriesChart from '../components/CapSeriesChart';
import GenericOptionsWidget from '../components/GenericOptionsWidget';

export default function Options() {
  // Shared timeframe state — both charts stay in sync.
  const [tf, setTf] = useState('1m');

  return (
    <div>
      <ChartWidget tf={tf} setTf={setTf} />
      <CapSeriesChart tf={tf} setTf={setTf} />
      <GenericOptionsWidget />
    </div>
  );
}
